import { render, staticRenderFns } from "./MaintenanceMessage.vue?vue&type=template&id=fed9e15c"
import script from "./MaintenanceMessage.vue?vue&type=script&lang=js"
export * from "./MaintenanceMessage.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceMessage.vue?vue&type=style&index=0&id=fed9e15c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports